import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { NewsPost } from '../../models/news-post';

export class NewsPostListApi {
    constructor(protected baseUrl: string) {}

    public getNewsPosts(searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<NewsPost>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/news-posts`, { params: searchParams }),
            response => response.data
        );
    }
}
